import { BaseService } from 'core/services';
import DocumentationRequestRouteService from './DocumentationRequestRouteService';

class DocumentationRequestService extends BaseService {
    constructor(apiClient) {
        super(apiClient, new DocumentationRequestRouteService());
    }

    getDownloadUrl() {
        return this.apiClient.appOptions.apiUrl + this.routeService.download();
    }

    getEmailPrefillData(facilityOrderId) {
        const url = this.routeService.getEmailPrefillData(facilityOrderId);
        return this.apiClient.get(url);
    }

    getNikoEmailPrefillData(facilityOrderId) {
        const url = this.routeService.getNikoEmailPrefillData(facilityOrderId);
        return this.apiClient.get(url);
    }

    sendEmail(resource) {
        const url = this.routeService.sendEmail(resource);
        return this.apiClient.post(url, resource);
    }

    checkMissingDocuments(resource) {
        const url = this.routeService.checkMissingDocuments(resource);
        return this.apiClient.get(url);
    }

    checkNikoMissingDocuments(resource) {
        const url = this.routeService.checkNikoMissingDocuments(resource);
        return this.apiClient.get(url);
    }

    hasPreviousDosTemplates(resource) {
        const url = this.routeService.hasPreviousDosTemplates(resource);
        return this.apiClient.get(url);
    }
}

export default DocumentationRequestService;
